const ClinicNameRender = ({ clinicalDepartment }) =>
  clinicalDepartment.extraName
    ? `${clinicalDepartment.clinic.name} (${clinicalDepartment.extraName})`
    : clinicalDepartment.clinic.name

export default ClinicNameRender
